import React from 'react';

const defaultProvider = (Component, props) => <Component {...props} />;

const stepsFactory = (variantsList, variant = 'a', data = {}, withProvider = defaultProvider) => {
  if (!variantsList || !Object.keys(variantsList).includes(variant)) return null;

  const Component = variantsList[variant];
  return withProvider(Component, { ...data, variant });
};

export default stepsFactory;
